
export enum SessionDuration { 
    duration25Mins = 1,
    duration50Mins = 2,
    duration80Mins = 4
}

